import axios from './axios';
import config from '../../helpers/config';

export default apiRequest => (
  axios.put(config.designBuilderSaveDesignPath, apiRequest)
);
